import React from 'react'
import Alert from 'react-bootstrap/Alert'

export function mergeValidationErrors(formErrors, pageErrors) {
    return { ...(pageErrors || {}), ...(formErrors || {}) }
}

export function validationMessage(errors, key) {
    const e = errors?.[key]
    if (!e) {
        return null
    }

    return Array.isArray(e) ? e[0] : e
}

export default function FormValidationSummary({ errors }) {
    const entries = Object.entries(errors || {}).filter(([, value]) => value)

    if (entries.length === 0) {
        return null
    }

    return (
        <Alert variant="danger" className="mb-6">
            <Alert.Heading className="fs-6 mb-3">Revisa los siguientes campos:</Alert.Heading>
            <ul className="mb-0 ps-4">
                {entries.map(([key]) => (
                    <li key={key}>{validationMessage(errors, key)}</li>
                ))}
            </ul>
        </Alert>
    )
}
